// Color utilities for context views

/**
 * Calculate the absolute midpoint (0-1) of a child node given its parent's absolute position
 * @param parentAbsTop - Parent's absolute top position (0-100 percent)
 * @param parentAbsHeight - Parent's absolute height (0-100 percent)
 * @param childRelTop - Child's relative top within parent (0-1 fraction)
 * @param childRelHeight - Child's relative height within parent (0-1 fraction)
 * @returns Normalized midpoint (0-1) for color mapping
 */
export function calculateChildAbsMidPercent(
    parentAbsTop: number,
    parentAbsHeight: number,
    childRelTop: number,
    childRelHeight: number
): number {
    const childRelMid = childRelTop + childRelHeight / 2;
    const childAbsMid = parentAbsTop + parentAbsHeight * childRelMid;
    return childAbsMid / 100; // Convert 0-100 to 0-1
}

// Calculate position-based hue for a node
export function calculateNodeHueFromPercent(midPercent: number): number {
    // Map 0..1 to a perceptually pleasant blue/purple range (180..260)
    const hue = 180 + (Math.max(0, Math.min(1, midPercent)) * 80);
    return hue;
}

// Solid accent color for rails and thin elements
export function nodeAccentColorFromPercent(midPercent: number, isDarkMode: boolean): string {
    const hue = calculateNodeHueFromPercent(midPercent);
    return `hsl(${hue}, 65%, ${isDarkMode ? 45 : 50}%)`;
}

// Glassy background tint for blocks
export function nodeBackgroundTintFromPercent(midPercent: number, isHighlighted: boolean, isDarkMode: boolean, isPreview = false): string {
    const hue = calculateNodeHueFromPercent(midPercent);
    if (isHighlighted) {
        return `hsla(${hue}, 60%, ${isDarkMode ? 50 : 55}%, ${isPreview ? 0.5 : 0.25})`;
    }
    return `hsla(${hue}, 50%, ${isDarkMode ? 45 : 50}%, ${isPreview ? 0.35 : 0.15})`;
}


